import React from "react";
import { connect } from "react-redux";
import { inlineElements, generateStyle, setOverLay, l } from "../../functions";

import { MyDraggable as Draggable } from "../../components/Core";
import HoverBar from "../../components/HoverBar";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Container, Row, Col } from "reactstrap";
import state from "../../state";
import Icon from "../../components/Icons";
import axios from "axios";
import GKEvent from "../../events";
import { ajaxUri } from "../../consts/index";
import isEqual from "lodash/isEqual";

const mapStateToProps = (state) => {
  return {
    fetchedProducts: state.rootReducer.fetchedProducts || {},
    settings: state.rootReducer?.appearanceSettings || {},
  };
};

class CheckoutSummary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      EZCONF_SHOW_INSTANT_DISCOUNT: 0,
    };

    GKEvent.addEventListener("updateState", (key, value) => {
      this.setState({
        [key]: value,
      });
    });
  }
  shouldComponentUpdate(nextProp, nextState) {
    if (
      !isEqual(this.props?.payload, nextProp?.payload) ||
      !isEqual(this.props?.settings, nextProp?.settings) ||
      !isEqual(this.state, nextState)
    ) {
      return true;
    }

    return false;
  }

  componentDidMount() {
    this._getSetting("EZCONF_SHOW_INSTANT_DISCOUNT");
  }

  _getSetting = (key) => {
    axios({
      method: "post",
      url: ajaxUri,
      data: {
        request: "getSetting",
        key: key,
      },
    })
      .then((result) => {
        this.setState({
          [key]: result.data,
        });
      })
      .catch((error) => {
        GKEvent.notification("error", "Error.");
      });
  };

  _initSummary = () => {
    let { payload } = this.props;

    if (payload === null) payload = this.props.options.payload;

    const settings = this.props.settings || {};
    let textsettings = {};

    const cssSettings = generateStyle(payload, "container");
    const cssSettingsText = generateStyle(payload, "text", "body");

    let { priceColor, tableBgColor, tableBorderColor } = payload.datas || {};
    if (settings["price_color"] && priceColor === "#f042a8") {
      priceColor = settings["price_color"]?.color || priceColor;
    }
    let oldPriceColor = priceColor;
    if (settings["old_price_color"]) {
      oldPriceColor = settings["old_price_color"]?.color;
    }

    cssSettingsText.textAlign = null;

    textsettings = { ...cssSettingsText };

    let labelTextSettings = { ...cssSettingsText };
    let buttonStyle = {};
    if (settings["active_button_text_color"]) {
      buttonStyle.color = settings["active_button_text_color"]?.color || "#fff";
    }
    if (settings["active_button_color"]) {
      buttonStyle.backgroundColor =
        settings["active_button_color"]?.bgColor || "#2f862d";
      buttonStyle.borderColor =
        settings["active_button_color"]?.bgColor || "#2f862d";
    }

    if (settings["body"]) {
      const setting = settings["body"];
      const fontFamily =
        settings["body_font"] && settings["body_font"].fontFamily;
      textsettings = {
        ...textsettings,
        color: textsettings.color || setting.color,
        fontFamily: fontFamily,
        fontSize: textsettings.size || setting.size,
      };
    }

    if (settings["semi_body_color"] || settings["semiBody"]) {
      labelTextSettings = {
        ...labelTextSettings,
        color: settings["semi_body_color"]?.color,
        fontFamily: settings["body_font"] && settings["body_font"].fontFamily,
        fontSize: settings["semiBody"]?.size,
      };
    }
    return (
      <Container fluid={payload.fullContainer} style={cssSettings}>
        {setOverLay(payload)}
        <Row>
          <Col
            xs={12}
            className="fullcol checkout-product-summary"
            style={cssSettingsText}
          >
            <div className="overlay"></div>
            <div
              className="checkoutproductdetails"
              style={{
                backgroundColor: tableBgColor ? tableBgColor : "#fafafa",
                borderColor: tableBorderColor ? tableBorderColor : "#cccccc",
              }}
            >
              <table border="0" style={{ tableLayout: "fixed" }}>
                <tbody>
                  {Object.keys(this.props.fetchedProducts)
                    .slice(0, 3)
                    .map((id_product, key) => {
                      const product = this.props.fetchedProducts[id_product];

                      return (
                        <tr key={key}>
                          <td
                            style={{
                              borderColor: tableBorderColor
                                ? tableBorderColor
                                : "#cccccc",
                            }}
                          >
                            <div className="pro_img">
                              <img
                                src={product.image}
                                alt="product"
                                width="80"
                              />
                              <span className="qty_round">1 </span>
                            </div>
                          </td>
                          <td
                            style={{
                              borderColor: tableBorderColor
                                ? tableBorderColor
                                : "#cccccc",
                            }}
                          >
                            <div className="product-name" style={textsettings}>
                              {product.name}
                            </div>
                            <span className="attr" style={labelTextSettings}>
                              {" "}
                              Color : Coffee, <br /> Ships From : China{" "}
                            </span>
                          </td>
                          <td
                            className="price_txt"
                            style={{
                              color: priceColor ? priceColor : "#f042a8",
                              borderColor: tableBorderColor
                                ? tableBorderColor
                                : "#cccccc",
                            }}
                          >
                            <span
                              style={{
                                display: "block",
                                color: oldPriceColor,
                                textDecorationLine: "line-through",
                                fontSize: "75%",
                              }}
                            >
                              $100.00
                            </span>
                            $99.0
                          </td>
                        </tr>
                      );
                    })}
                  {(this.state.EZCONF_SHOW_INSTANT_DISCOUNT == 1 && (
                    <tr className="discount_td">
                      <td
                        colSpan={2}
                        style={{
                          borderColor: tableBorderColor
                            ? tableBorderColor
                            : "#cccccc",
                        }}
                      >
                        <div className="input-box">
                          <input type="text"></input>
                          <label style={textsettings}>Discount</label>
                        </div>
                      </td>
                      <td
                        style={{
                          borderColor: tableBorderColor
                            ? tableBorderColor
                            : "#cccccc",
                        }}
                      >
                        <button
                          id="savebtn"
                          type="submit"
                          className="btn btn-success pull-right"
                          style={buttonStyle}
                        >
                          Apply
                        </button>
                      </td>
                    </tr>
                  )) || (
                    <tr className="discount_td">
                      <td colSpan={3}>
                        <span>
                          <FontAwesomeIcon icon={["fas", "plus-circle"]} />{" "}
                          <span>{l("Have a Discount Code ?")}</span>
                        </span>
                      </td>
                    </tr>
                  )}
                </tbody>
                <tfoot>
                  <tr className="subtotal">
                    <td
                      style={{
                        borderColor: tableBorderColor
                          ? tableBorderColor
                          : "#cccccc",
                      }}
                    >
                      Subtotal
                    </td>
                    <td
                      className="hide-xs"
                      style={{
                        borderColor: tableBorderColor
                          ? tableBorderColor
                          : "#cccccc",
                      }}
                    ></td>
                    <td
                      className="price_txt"
                      style={{
                        color: priceColor ? priceColor : "#f042a8",
                        borderColor: tableBorderColor
                          ? tableBorderColor
                          : "#cccccc",
                      }}
                    >
                      --
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </Col>
        </Row>
      </Container>
    );
  };

  render() {
    const {
      dropzoneID,
      parentID,
      showBasicContent,
      showPreview,
      id,
      dropzoneProps,
      payload,
      options,
      ...rest
    } = this.props;

    if (showBasicContent) {
      const elements = state.getStorableState();
      let inDrop = false;

      if (Array.isArray(elements) && elements.length > 0) {
        const inlinedElements = inlineElements(elements);
        if (Array.isArray(inlinedElements) && inlinedElements.length > 0) {
          inlinedElements.forEach((element) => {
            if (element.type === this.props.type) inDrop = true;
          });
        } else inDrop = false;
      } else inDrop = false;

      return (
        <Draggable {...this.props} side={true}>
          <span className="dragger">
            {(Array.isArray(rest.icon) && (
              <FontAwesomeIcon icon={rest.icon} />
            )) || <Icon icon={rest.icon} />}
            <span>{l(rest.name)}</span>
            {(inDrop && <span className="added">{l("Added")}</span>) || (
              <span className="required">{l("Required")}</span>
            )}
          </span>
        </Draggable>
      );
    }

    if (showPreview) {
      return <div>{this._initSummary()}</div>;
    }

    return (
      <Draggable {...this.props} minify={true}>
        <HoverBar
          datas={this.props}
          style={payload}
          parent={parentID}
          element={{ id, dropzoneID, parentID, payload }}
        />
        {this._initSummary()}
      </Draggable>
    );
  }
}

export default connect(mapStateToProps)(CheckoutSummary);
